import { ISettingInfo, IWritableSettings, ObjectHelper } from '@barthauer/abc/core';
import { DataFormatTheme, DataFormStyle } from '../../abc-arena.service';
import { StylingMode } from '@barthauer/abc/ui-components';

export enum DataFormSetting {
  style,
  theme,
}
export interface StyleDataFormSettings {
  tabs?: DataFormStyle;
  orientation?: 'horizontal' | 'vertical';
  stylingMode?: StylingMode;
}
export interface IDataFormSettings {
  readonly style: StyleDataFormSettings;
  readonly theme: DataFormatTheme;
}

export class DataFormSettings implements IDataFormSettings, IWritableSettings<IDataFormSettings> {
  public static readonly Infos: ReadonlyMap<DataFormSetting, ISettingInfo> = new Map<DataFormSetting, ISettingInfo>([
    [
      DataFormSetting.style,
      {
        settingName: ObjectHelper.nameof<IDataFormSettings>('style'),
        responsePropertyName: ObjectHelper.nameof<IDataFormSettings>('style'),
        settingValueType: Object,
      },
    ],
    [
      DataFormSetting.theme,
      {
        settingName: ObjectHelper.nameof<IDataFormSettings>('theme'),
        responsePropertyName: ObjectHelper.nameof<IDataFormSettings>('theme'),
        settingValueType: String,
      },
    ],
  ]);

  theme: DataFormatTheme = DataFormatTheme.DEFAULT;
  style: {} = {};

  load(settings: IDataFormSettings): void {
    this.style = settings?.style ?? {};
    this.theme = settings?.theme ?? DataFormatTheme.DEFAULT;
  }
}
